export class UpdateObjectStoreScanMethodRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cdcBackup",
            "baseName": "cdcBackup",
            "type": "ObjectStoreScanMethodSetting",
            "format": ""
        },
        {
            "name": "inventoryBackup",
            "baseName": "inventoryBackup",
            "type": "ObjectStoreScanMethodSetting",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateObjectStoreScanMethodRequest.attributeTypeMap;
    }
    constructor() {
    }
}
